<script setup lang="ts">
import { computed } from 'vue';
import { useFetch } from '#app/composables/fetch';

interface Props {
  // FIXME: トンマナを揃えるため、レシピの場合とニュースの場合で各パーツの色を変えている。
  // 将来的に統一できればだいぶコード減りそう
  isRecipeDesign?: boolean;
}

const props = defineProps<Props>();

const titleCardColor = computed(() => {
  return props.isRecipeDesign ? 'beige' : null;
});

const pickupItemsResponse = await useFetch('/api/kiwi_user/articles/pickup');
const pickupItems = pickupItemsResponse.data.value ?? [];
</script>

<template>
  <aside>
    <AtomsGoogleAd id="div-gpt-ad-1473215132261-0" target="pc" class="mb-5" />

    <NuxtLink
      to="/s/service_dietplus"
      target="_blank"
      rel="noopener"
      class="hover:opacity-40 duration-300 block mb-5"
      ><img src="@/assets/img/dpapp_banner.png"
    /></NuxtLink>

    <OrganismsNewsPickUp
      :items="pickupItems"
      class="mb-5"
      :color="titleCardColor"
    />

    <AtomsFacebookWidget class="mb-5" />
    <AtomsXFollowCard class="mb-5" />

    <AtomsFytteBanner />
  </aside>
</template>
